import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {
  Button,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  IconButton,
  Divider,
} from '@mui/material';
import { CustomLabel } from 'components/shared';
import { formatPhone } from 'utils/format_phone';

const labelStyle = {
  color: '#00000099',
  fontFamily: 'Roboto',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20.02px',
  letterSpacing: '0.17px',
  textAlign: 'left',
};

const valueStyle = {
  fontFamily: 'Roboto',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  textAlign: 'left',
};
interface PersonalDataDisplayProps {
  values: {
    name: string;
    cpf: string;
    email: string;
    phone: string;
    position: string;
    municipality: string;
  };
  onEditClick?: () => void;
  isView: boolean;
}

const PersonalDataDisplay: React.FC<PersonalDataDisplayProps> = ({
  values,
  isView,
  onEditClick,

}) => {
  const [expanded, setExpanded] = useState(true);



  const handleEditClick = (event: React.MouseEvent) => {
    if (onEditClick) {
      event.stopPropagation();
      onEditClick();
    }
  };

  const handleAccordionToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Box sx={{ width: '1152px', marginTop: '20px' }}>
      <Accordion expanded={expanded} onChange={handleAccordionToggle}>
        <AccordionSummary
          expandIcon={null}
          sx={{ alignItems: 'center', display: 'flex', }}
        >
          <Box
            sx={{
              flexWrap: 'nowrap',
              display: 'flex',
              flexDirection: 'column',
              width: '100%',


            }}
          >
            <Box sx={{ display: 'flex' }}>
              <IconButton
                onClick={handleAccordionToggle}
                sx={{
                  marginRight: '10px',
                  transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease-in-out',
                }}
              >
                <ExpandMoreIcon />
              </IconButton>

              <Typography variant='h6'>Dados pessoais</Typography>
              {!isView && (
                <Button
                  startIcon={<EditOutlinedIcon />}
                  variant='text'
                  sx={{
                    textTransform: 'none',
                    marginLeft: 'auto',
                    color: '#0048B6',
                  }}
                  onClick={handleEditClick}
                >
                  Editar
                </Button>
              )}
            </Box>
            {expanded && (
              <Box sx={{ width: '100%' }}>
                <Divider sx={{ border: '1px solid #0000001F' }} />
              </Box>
            )}
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '20px',
            }}
          >
            {/* Bloco de Nome e CPF */}
            <Box
              sx={{
                display: 'flex',
                marginBottom: '20px',
                flexDirection: 'row',
              }}
            >
              <Box sx={{ display: 'flex', width: '520px', flexDirection: 'column' }}>
                <CustomLabel text='Nome Completo' labelStyle={labelStyle} />
                <CustomLabel
                  text={(values.name ?? '').trim().toUpperCase()}
                  labelStyle={valueStyle}
                />
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '520px',
                }}
              >
                <CustomLabel text='CPF' labelStyle={labelStyle} />
                <CustomLabel text={values.cpf} labelStyle={valueStyle} />
              </Box>
            </Box>
            {/* Bloco de E-mail e Telefone */}
            <Box
              sx={{
                display: 'flex',
                marginBottom: '20px',
                flexDirection: 'row',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '520px',
                }}
              >
                <CustomLabel text='E-mail' labelStyle={labelStyle} />
                <CustomLabel text={values.email} labelStyle={valueStyle} />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '520px',
                }}
              >
                <CustomLabel text='Telefone' labelStyle={labelStyle} />
                <CustomLabel
                  text={formatPhone(values.phone)}
                  labelStyle={valueStyle}
                />
              </Box>
            </Box>
            {/* Bloco de Cargo/Função e Município */}
            <Box
              sx={{
                flexDirection: 'row',
                display: 'flex',
                marginBottom: '20px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '520px',
                }}
              >
                <CustomLabel text='Cargo/Função' labelStyle={labelStyle} />
                <CustomLabel text={values.position} labelStyle={valueStyle} />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '520px',
                }}
              >
                <CustomLabel text='Município' labelStyle={labelStyle} />
                <CustomLabel
                  text={values.municipality}
                  labelStyle={valueStyle}
                />
              </Box>
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default PersonalDataDisplay;
